import { render, staticRenderFns } from "./GAreaChart.vue?vue&type=template&id=676e29ac&"
import script from "./GAreaChart.vue?vue&type=script&lang=js&"
export * from "./GAreaChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports